import { useMediaQuery, createSharedComposable } from '@vueuse/core'
import { H5_WIDTH_THRESHOLD } from '@components/Constants'
import { useSharedActiveMenuItem } from '@/core/compositions/ActiveMenuItem'
import { computed } from 'vue'
import { MicroAppId } from '@core/application/ApplicationConstants'

const useScreen = () => {
  const { isFileManager, activeAppId } = useSharedActiveMenuItem()
  const isLargeScreen = useMediaQuery(`(min-width: ${H5_WIDTH_THRESHOLD})`)
  const isStandardScreen = computed(
    () =>
      isLargeScreen.value ||
      (!isFileManager.value && !((activeAppId.value as unknown as MicroAppId) === MicroAppId.DEV_INTEGRATION))
  )

  return {
    isStandardScreen,
    isLargeScreen,
  }
}

export const useSharedScreen = createSharedComposable(useScreen)
